import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Button, ButtonToolbar, Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';

import { fetchRoutesPrinter, saveRoutesPrinter, saveRoutesPrinterSuccess } from '../../actions/dispatch_actions';

class EditRoutePrinterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // data: this.props.allRoutes,
      rows: [],
    };
  }

  componentDidMount() {
    this.props.fetchRoutesPrinter();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.routesPrinters) {
      this.setState({
        rows: nextProps.routesPrinters,
      });
    }
    if (nextProps.savePrinterSuccess) {
      this.props.saveRoutesPrinterSuccess(false);
      this.props.close();
    }
  }

  save = () => {
    this.props.saveRoutesPrinter(this.state.rows);
  }

  renderTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleRowUpdated = (e) => {
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      this.setState({
        rows,
      });
    };

    const columns = [
      {
        key: 'RouterId',
        name: <Translate value="RouterId" />,
        resizable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      {
        key: 'RunTime',
        name: <Translate value="RunTime" />,
        resizable: true,
        editable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
    ];

    return (
      <Row>
        <Col>
          <div>
            <ReactDataGrid
              rowKey="router_printer_table001"
              enableCellSelect
              onRowUpdated={handleRowUpdated}
              rowHeight={25}
              minHeight={675}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
            />
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <div id="edit-route-modal">
        <ButtonToolbar style={{ marginBottom: '10px' }}>
          <Button
            bsStyle="primary"
            className="buttonStyle"
            onClick={event => this.save(event)}
          >
            <em className="fa fa-save marginRightStyle" />
            <Translate value="save" />
          </Button>
        </ButtonToolbar>
        {this.renderTable()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    routesPrinters: state.dispatch.routesPrinters,
    savePrinterSuccess: state.dispatch.savePrinterSuccess,
  };
}

export default connect(mapStateToProps, {
  fetchRoutesPrinter,
  saveRoutesPrinter,
  saveRoutesPrinterSuccess,
})(EditRoutePrinterModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/EditRoutePrinterModal.jsx